module.exports = __webpack_public_path__ + "img/product-preview-2.b05fe0a.png";